"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Body = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Body = exports.Body = _styledComponents["default"].div.withConfig({
  displayName: "Body",
  componentId: "sc-19u46fy-0"
})(["", " padding-inline:", ";padding-block-end:", ";overflow:auto;"], _index.browserFocusReset, (0, _index.cssSpacing)('looser', '20px'), (0, _index.cssSpacing)('base', '16px'));